requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('product-recommendations')) {
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();
        }

        extractProductRecommendations(html) {
          const match = html.match(/<product-recommendations[^>]*>([\s\S]*?)<\/product-recommendations>/);
          return match ? match[1].trim() : '';
        }

        connectedCallback() {
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const recommendationsHTML = this.extractProductRecommendations(text);

                if (recommendationsHTML.length) {
                  this.innerHTML = lazyTemplateController.cleanHTMLWithTemplate(recommendationsHTML);
                }
                if (!this.querySelector('slider-component') && this.classList.contains('complementary-products')) {
                  this.remove();
                }
                if (html.querySelector('.slider__slide')) {
                  this.classList.add('product-recommendations--loaded');
                }

                window.dispatchEvent(new CustomEvent('MutationObserverLoaded'));
                window.lazyImages.find();
              })
              .catch((e) => {
                console.error(e);
              });
          };

          new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '1000px 0px 1000px 0px'
          }).observe(this);
        }
      }

      customElements.define('product-recommendations', ProductRecommendations);
    }
  });
});